module.exports = __webpack_public_path__ + "img/007-graphic-design-3.31033645.svg";